import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';

console.log(`Field Report version ${process.env.REACT_APP_VERSION}`);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
